import { Box } from "@mui/material";
import * as React from "react";
import SKUSwitch from "./SKUSwitchUpdated";

export default function SKU_Replacement() {
  return (
    <Box>
      <SKUSwitch />
    </Box>
  );
}
